import { Injectable } from '@angular/core';
import { CalendarDay, CalendarRow } from 'src/app/models/agenda/calendar.model';
import * as moment from 'moment';

@Injectable()
export class CalendarService {

  public year: number = -1;
  public nextYear: number = -1;

  public thisMonthName: string = '';
  private thisMonthNumber: number = -1;
  private thisMonthDaysNumber: CalendarDay = new CalendarDay(-1, false);

  private previousMonthNumber: number = -1;
  private previousMonthDaysNumber: number = -1;

  public rows: CalendarRow[] = [];

  public eventDays: any[] = [];

  constructor() {
    this.year = Number(moment().format('YYYY'));
    this.nextYear = this.year + 1;

    this.thisMonthName = moment().format('MMMM');
    this.thisMonthNumber = Number(moment().format('MM'));

    if (this.thisMonthNumber > 1) this.previousMonthNumber = this.thisMonthNumber - 1;
    else this.previousMonthNumber = 12;

    this.thisMonthDaysNumber.day = moment(this.year.toString() + '-' + this.thisMonthNumber.toString(), "YYYY-MM").daysInMonth();
    this.previousMonthDaysNumber = moment(this.year.toString() + '-' + this.previousMonthNumber.toString(), "YYYY-MM").daysInMonth();
    this.buildRows();
  }

  public buildRows() {
    this.rows = [];
    let firstMonthWeekDay : number = Number(moment(this.year.toString() + '-' + this.thisMonthNumber.toString() + '-01', "YYYY-MM-DD").format('d'));
    let dayCounter = 0;
    let firstRowCompleted: boolean = false;

    do {
      let calendarRow: CalendarRow = new CalendarRow();
      calendarRow.days = [];
      for (let i = 0; i < 7; i++) {
        if ((i + 1 >= firstMonthWeekDay) || firstRowCompleted) {
          let day: number = -1;
          let eventDay: boolean = false;
          let dateCheck: any = { day : day, month : this.thisMonthNumber };
          if (dayCounter >= this.thisMonthDaysNumber.day) {
            day = dayCounter - this.thisMonthDaysNumber.day + 1;
            dateCheck.day = day;
            eventDay = this.eventDays.findIndex((date : any) => date.day == dateCheck.day && date.month == dateCheck.month) > -1 ? true : false;
            calendarRow.days.push(new CalendarDay(day, eventDay));
          } else {
            day = dayCounter + 1;
            dateCheck.day = day;
            eventDay = this.eventDays.findIndex((date : any) => date.day == dateCheck.day && date.month == dateCheck.month) > -1 ? true : false;
            calendarRow.days.push(new CalendarDay(day, eventDay));
          }
          dayCounter++;
        } else calendarRow.days.push(new CalendarDay((this.previousMonthDaysNumber - firstMonthWeekDay) + 1 + (i+1)));

      }
      this.rows.push(calendarRow);
      if(this.rows.length === 1) firstRowCompleted = true;
    }
    while (dayCounter < this.thisMonthDaysNumber.day);

  }
}
